import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { IDraw } from '../pages/DrawPage/DrawItem';
import { useSelector } from '.';

export const useCurrentDraw = () => {
    const [draw, setDraw] = useState<IDraw | undefined>();
    const { drawId } = useParams();
    const draws = useSelector(store => store.draws.items);

    useEffect(() => {
        const currentDraw = draws.find(draw => draw.drawId === parseInt(drawId ?? '0'));
        setDraw(currentDraw);
    }, [drawId, draws]);

    return draw;
};